import renderHelpdeskPage from './helpdesk/helpdesk';

require('./sass/base.sass');

module.exports = {
	renderHelpdeskPage,
	components: {
		CookieBanner: require("sma.common/components/cookie_banner"),
		Rely: require('sma.admin/components/rely'),
	}
};
